import FastIcon from "@/app/icons/fast.svg";
import SupportIcon from "@/app/icons/support.svg";
import IdeaIcon from "@/app/icons/idea.svg";

export const servicesData = [
    {
        "title": "Fast & Easy",
        "description": "Open your account quickly with our streamlined process.",
        "icon": FastIcon,
    },
    {
        "title": "Expert Support",
        "description": "We navigate the banking landscape, so you don’t have to.",
        "icon": SupportIcon,
    },
    {
        "title": "Tailored Solutions",
        "description": "Designed for startups, SMEs, and global enterprises.",
        "icon": IdeaIcon,
    },
];